module.exports = __webpack_public_path__ + "img/sld_abt_main.991d5bd4.svg";